import React from 'react';
import './Services.css';

const Services = () => {
    return (
        <div className="services">
            <h2>My Services</h2>
            <p>Details about the services I offer will be listed here.</p>
        </div>
    );
};

export default Services;
